import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const recalculateScenario = api(async function recalculateScenario({ id }) {
    return mutate(
        gql`
            mutation RecalculateScenario($id: String!) {
                recalculateScenario(id: $id)
            }
        `,
        { id },
        { returns: "recalculateScenario" }
    )
})
